import React from 'react';
import { Text } from '@fragments';
import './styles.scss';

// The profile the onboarding will create, field by field, before the creator finishes.
export default function ProfileSummary({ rows, t }) {
  return <dl className="studio-profile-summary">
    {rows.map(row => <div key={row.key} className="studio-profile-summary__row">
      <dt><Text.caption contrast={6}>{t(`onboardingSummary_${row.key}`)}</Text.caption></dt>
      <dd><Text.span contrast={9}>{row.value}</Text.span></dd>
    </div>)}
  </dl>;
}
